const products = [
  {
    proteins: [
      {
        id: 1,
        name: "Chicken Breast",
        value: 25
      },
      {
        id: 2,
        name: "Cicken Drumstick",
        value: 35
      },
      {
        id: 3,
        name: "Chicken Wings",
        value: 46
      },
      {
        id: 4,
        name: "Turkey Breast",
        value: 21
      },
      {
        id: 5,
        name: "Turkey Fillet",
        value: 21
      },
      {
        id: 6,
        name: "Turkey Wings",
        value: 51
      },
      {
        id: 7,
        name: "Duck Breast",
        value: 35
      },
      {
        id: 8,
        name: "Chicken Liver",
        value: 34
      },
      {
        id: 9,
        name: "Pork Tenderloin",
        value: 29
      },
      {
        id: 10,
        name: "Pork Liver",
        value: 41
      },
      {
        id: 11,
        name: "Beef Silverside",
        value: 27
      },
      {
        id: 12,
        name: "Beef Entrecote",
        value: 38
      },
      {
        id: 13,
        name: "Beef Roast",
        value: 38
      },
      {
        id: 14,
        name: "Sirloin",
        value: 28
      },
      {
        id: 15,
        name: "Veal",
        value: 27
      },
      {
        id: 16,
        name: "Egg White",
        value: 12
      },
      {
        id: 17,
        name: "Chicken Ham",
        value: 30
      },
      {
        id: 18,
        name: "Shrimps",
        value: 20
      },
      {
        id: 19,
        name: "Squids",
        value: 23
      },
      {
        id: 20,
        name: "Cod",
        value: 20
      },
      {
        id: 21,
        name: "Alaska Pollock",
        value: 20
      },
      {
        id: 22,
        name: "Hoki",
        value: 20
      },
      {
        id: 23,
        name: "Halibut",
        value: 22
      },
      {
        id: 24,
        name: "Trout",
        value: 40
      },
      {
        id: 25,
        name: "Smoked Trout",
        value: 29
      },
      {
        id: 26,
        name: "Canned Tuna",
        value: 27
      },
      {
        id: 27,
        name: "Tuna",
        value: 32.5
      },
      {
        id: 28,
        name: "Sole",
        value: 25
      },
      {
        id: 29,
        name: "Natural Tofu",
        value: 28
      },
      {
        id: 30,
        name: "Somked Tofu",
        value: 42
      },
      {
        id: 31,
        name: "Low fat Quark",
        value: 28
      },
      {
        id: 32,
        name: "Natural Skyr",
        value: 16
      },
      {
        id: 33,
        name: "Cottage Cheese",
        value: 20
      },
      {
        id: 34,
        name: "Greek Yoghurt",
        value: 15
      },
      // {
      //   id: 35,
      //   name: ,
      //   value: 
      // }
    ],
    carbs: [
      {
        id: 1,
        name: "Brown Rice",
        value: 83.75
      },
      {
        id: 2,
        name: "Basmati Rice",
        value: 87.5
      },
      {
        id: 3,
        name: "Millet",
        value: 87
      },
      {
        id: 4,
        name: "Buckwheat Groats",
        value: 86
      },
      {
        id: 5,
        name: "Barley Groats",
        value: 83.7
      },
      {
        id: 6,
        name: "Bulgur Grits",
        value: 90
      },
      {
        id: 7,
        name: "Cous Cous",
        value: 90
      },
      {
        id: 8,
        name: "Rye Bread",
        value: 57
      },
      {
        id: 9,
        name: "Oat Flakes",
        value: 91.5
      },
      {
        id: 10,
        name: "Rye Pasta",
        value: 86
      },
      {
        id: 11,
        name: "Spelled Pasta",
        value: 87.5
      },
      {
        id: 12,
        name: "Rice Noodles",
        value: 91.5
      },
      {
        id: 13,
        name: "Buckweat Noodles",
        value: 87.5
      },
      {
        id: 14,
        name: "Potatoes",
        value: 20
      },
      {
        id: 15,
        name: "Sweet Potatoes",
        value: 20
      },
      {
        id: 16,
        name: "WhiteRice",
        value: 86
      },
      {
        id: 17,
        name: "Banana",
        value: 25
      },
      {
        id: 18,
        name: "Quinoa",
        value: 83.75
      },
      {
        id: 19,
        name: "Rice Waffles",
        value: 100
      },
      {
        id: 20,
        name: "Corn Wafers",
        value: 94
      },
      {
        id: 21,
        name: "Buckwheat Flour",
        value: 87.5
      },
      {
        id: 22,
        name: "Millet Flour",
        value: 94
      },
      {
        id: 23,
        name: "Wholegrain Tortilla",
        value: 72
      },
      {
        id: 24,
        name: "Rye Flour",
        value: 83.75
      },
      {
        id: 25,
        name: "Rice Flour",
        value: 87.5
      },
      {
        id: 26,
        name: "Wholegrain Wheat Flour",
        value: 86
      },
      {
        id: 27,
        name: "Potato Flour",
        value: 83.75
      },
      {
        id: 28,
        name: "Rice Gruel",
        value: 83.75
      },
      {
        id: 29,
        name: "Manioc",
        value: 30
      },
      {
        id: 30,
        name: "Tapioca",
        value: 87.5
      },
      {
        id: 31,
        name: "Honey",
        value: 76
      },
      {
        id: 32,
        name: "Dates",
        value: 72.5
      },
      {
        id: 33,
        name: "Raisins",
        value: 71
      },
      {
        id: 34,
        name: "Dried Bananas",
        value: 87.5
      },
      {
        id: 35,
        name: "Dried Figs",
        value: 77.5
      }
    ],
    fat: [
      {
        id: 1,
        name: "Olive Oil",
        value: 100
      },
      {
        id: 2,
        name: "Avocado",
        value: 18
      },
      {
        id: 3,
        name: "Avocado Oil",
        value: 100
      },
      {
        id: 4,
        name: "Ghee Butter",
        value: 100
      },
      {
        id: 5,
        name: "Butter",
        value: 80
      },
      {
        id: 6,
        name: "Walnuts",
        value: 74
      },
      {
        id: 7,
        name: "Cashews",
        value: 61
      },
      {
        id: 8,
        name: "Halzenuts",
        value: 69
      },
      {
        id: 9,
        name: "Almonds",
        value: 68
      },
      {
        id: 10,
        name: "Pini Nuts",
        value: 74
      },
      {
        id: 11,
        name: "Pistachios",
        value: 64
      },
      {
        id: 12,
        name: "Brazil Nuts",
        value: 72
      },
      {
        id: 13,
        name: "Pekan Nuts",
        value: 76
      },
      {
        id: 14,
        name: "Almonds Blanched",
        value: 66
      },
      {
        id: 15,
        name: "Linseed Oil",
        value: 100
      },
      {
        id: 16,
        name: "Rapeseed Oil",
        value: 100
      },
      {
        id: 17,
        name: "Coconut Oil",
        value: 100
      },
      {
        id: 18,
        name: "Peanut Butter",
        value: 77
      },
      {
        id: 19,
        name: "Almond Butter",
        value: 68
      },
      {
        id: 20,
        name: "Cashew Butter",
        value: 65
      },
      {
        id: 21,
        name: "Halzenut Butter",
        value: 75
      },
      {
        id: 22,
        name: "Coconut Milk",
        value: 20
      },
      {
        id: 23,
        name: "Coconut Shreds",
        value: 77
      },
      {
        id: 24,
        name: "Tahini",
        value: 74
      },
      {
        id: 25,
        name: "Pesto",
        value: 57
      },
      {
        id: 26,
        name: "Bacon",
        value: 53
      },
      // {
      //   id: 27,
      //   name: ,
      //   value: 
      // },
      // {
      //   id: 28,
      //   name: ,
      //   value: 
      // },
      // {
      //   id: 29,
      //   name: ,
      //   value: 
      // },
      // {
      //   id: 30,
      //   name: ,
      //   value: 
      // },
      // {
      //   id: 31,
      //   name: ,
      //   value: 
      // },
      // {
      //   id: 32,
      //   name: ,
      //   value: 
      // },
      // {
      //   id: 33,
      //   name: ,
      //   value: 
      // },
      // {
      //   id: 34,
      //   name: ,
      //   value: 
      // },
      // {
      //   id: 35,
      //   name: ,
      //   value: 
      // }
    ],
    proteinFat: [
      {
        id: 1,
        name: "Salmon",
        value: 208
      },
      {
        id: 2,
        name: "Cold smoked salmon",
        value: 117
      },
      {
        id: 3,
        name: "Hot smoked salmon",
        value: 162
      },
      {
        id: 4,
        name: "Mackerel",
        value: 180
      },
      {
        id: 5,
        name: "Smoked mackerel",
        value: 221
      },
      {
        id: 6,
        name: "Smoked sprat",
        value: 243
      },
      {
        id: 7,
        name: "Herring",
        value: 217
      },
      {
        id: 8,
        name: "Smoked flounder",
        value: 117
      },
      {
        id: 9,
        name: "Pork neck",
        value: 205
      },
      {
        id: 10,
        name: "Soy sausages",
        value: 178
      },
      {
        id: 11,
        name: "Frankfurters",
        value: 270
      },
      {
        id: 12,
        name: "Mozzarella",
        value: 250
      },
      {
        id: 13,
        name: "Feta",
        value: 218
      },
      {
        id: 14,
        name: "Yellow cheese",
        value: 316
      },
      {
        id: 15,
        name: "Flax",
        value: 533
      },
    ]
  }
];

export default products;
